/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthClaimReadDto
 */
export interface AuthClaimReadDto {
    /**
     * 
     * @type {string}
     * @memberof AuthClaimReadDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthClaimReadDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the AuthClaimReadDto interface.
 */
export function instanceOfAuthClaimReadDto(value: object): value is AuthClaimReadDto {
    return true;
}

export function AuthClaimReadDtoFromJSON(json: any): AuthClaimReadDto {
    return AuthClaimReadDtoFromJSONTyped(json, false);
}

export function AuthClaimReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthClaimReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function AuthClaimReadDtoToJSON(json: any): AuthClaimReadDto {
    return AuthClaimReadDtoToJSONTyped(json, false);
}

export function AuthClaimReadDtoToJSONTyped(value?: AuthClaimReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

